import { ref, toValue, watch } from "vue";
export default function resettableValue(value, resettingField) {
    var result = ref(toValue(value));
    watch(resettingField, function () { return result.value = undefined; });
    watch(value, function () { return result.value = toValue(value); });
    return result;
}
